// extracted by mini-css-extract-plugin
export default {"about":"About_about__krMTz","cont":"About_cont__l-T3C","text":"About_text__MKlU3","img":"About_img__Fvmyr","abt":"About_abt__37stE","abtcont":"About_abtcont__amYzl"};